export class Area {
  ativo: boolean;
  id: number;
  codigoUnidadeOrcamentaria: string;
  nome: string;
  nomeResponsavel: string;
  emailResponsavel: string;
  telefoneResponsavel: string;
  orgaoId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/areas/shared/area.model.ts
 **/